<template>
  <BudgetDetail
    :budget="selectedBudget"
    :loading="loading"
    :budget-icon="budgetType.icon"
    :budget-label="budgetType.label"
    :transaction-groups="transactionGroups"
    :has-no-transactions="
      isFullTransactionList && !transactionGroups.length && !transactionsLoading
    "
    :transactions-loading="
      (!isFullTransactionList && !transactionGroups.length) ||
      transactionsLoading
    "
    @load:transactions="getNextTransactions"
  />
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import getBudgetTransactionGroups from '../../utils/get-budget-transaction-groups';

export default {
  name: 'BudgetDetailWidget',
  props: {
    budgetCategory: String
  },
  data() {
    const date = new Date();
    const monthOffset = 12;

    return {
      year: date.getFullYear(),
      month: date.getMonth(),
      dayOfMonth: date.getDate(),
      initialMonthOffset: monthOffset,
      monthOffset
    };
  },
  computed: {
    ...mapState({
      budgetSummary: (state) => state.budget.budgetSummary,
      loading: (state) => state.budget.budgetSummaryLoading,
      transactions: (state) => state.budget.budgetTransactions,
      transactionsLoading: (state) => state.budget.budgetTransactionsLoading,
      selectedLease: (state) => state.lease.selectedLease
    }),
    budgetType() {
      const type =
        this.$Constants.CLAIM_TYPES[this.budgetCategory.toLowerCase()] || {};
      return {
        label: type.label || 'Other',
        icon: type.icon
      };
    },
    transactionGroups() {
      return getBudgetTransactionGroups(this.transactions);
    },
    startDate() {
      return new Date(Date.UTC(this.year, this.month - this.monthOffset, 2));
    },
    endDate() {
      // The monthOffset value is for the start date so we need to ensure this is the end of the search period
      const offset = this.monthOffset - this.initialMonthOffset;
      const dayOfMonth = offset === 0 ? this.dayOfMonth : 1;
      return new Date(Date.UTC(this.year, this.month - offset, dayOfMonth));
    },
    selectedBudget() {
      const items = this.budgetSummary.items || [];
      const selection = items.find(
        (item) => item.budgetCategory === this.budgetCategory
      );
      return selection || {};
    },
    isFullTransactionList() {
      return (
        this.monthOffset >= this.selectedLease.currentMonth &&
        this.monthOffset !== this.initialMonthOffset
      );
    }
  },
  methods: {
    ...mapMutations('budget', ['clearBudgetTransactions']),
    ...mapActions('budget', ['getBudgetTransactions']),
    async getTransactions() {
      return await this.getBudgetTransactions({
        budgetCategory: this.budgetCategory,
        startDate: this.startDate,
        endDate: this.endDate
      });
    },
    async getNextTransactions({ done }) {
      // Do nothing if the full list has been fetched
      if (this.isFullTransactionList) {
        return;
      }
      // Get the list of transactions
      const transactions = await this.getTransactions();
      // Offset the next transaction period
      this.monthOffset = this.monthOffset + this.initialMonthOffset;
      // If there were no transactions, fetch for the next transaction period
      if (Array.isArray(transactions) && !transactions.length) {
        await this.getNextTransactions({});
      }
      if (done) {
        done();
      }
    }
  },
  beforeMount() {
    this.clearBudgetTransactions();
  },
  components: {
    BudgetDetail: () => import('../../components/organism/budget-detail')
  }
};
</script>
